// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__xgXVh"};